import type { AosFactionId } from "whole-shared";

import { ClientNighthaunt } from "./ClientNighthaunt";
import { ClientStormcastEternals } from "./ClientStormcastEternals";
import type { ClientAosFaction } from "./factions";

export * from "./ClientNighthaunt";
export * from "./ClientStormcastEternals";
export * from "./factions";

export const ClientAosFactions: { [key in AosFactionId]: ClientAosFaction } = { nh: ClientNighthaunt, se: ClientStormcastEternals };
